import { render, staticRenderFns } from "./zhibiaoku.vue?vue&type=template&id=ed10a874&scoped=true"
import script from "./zhibiaoku.vue?vue&type=script&lang=ts"
export * from "./zhibiaoku.vue?vue&type=script&lang=ts"
import style0 from "./zhibiaoku.vue?vue&type=style&index=0&id=ed10a874&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed10a874",
  null
  
)

export default component.exports